// The app shows a pack only when hours > 0 && price > 0 (CheckoutScreen.js:119)
// — mirror that here so a saved plan is never silently invisible.
export const validatePlan = ({ hours, price }) => {
  const errors = {};
  if (!Number.isInteger(hours) || hours < 1)
    errors.hours = "Sessions must be a whole number, 1 or more";
  if (!(Number(price) > 0)) errors.price = "Price must be more than £0";
  return errors;
};

// D5: the dashboard nudges toward exactly one featured plan, never enforces.
export const featuredStateWarning = (plans) => {
  const n = plans.filter((p) => p.featured === true).length;
  if (n === 1) return null;
  if (n === 0) return "No plan is featured — the app will show no “Most popular” ribbon.";
  return `${n} plans are featured — the app will ribbon all of them.`;
};
